import { render, staticRenderFns } from "./AtencionLaboratorios.vue?vue&type=template&id=275ddb5d"
import script from "./AtencionLaboratorios.vue?vue&type=script&lang=js"
export * from "./AtencionLaboratorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports